import { Stack } from "@mantine/core";
import { Customer } from "../services/customerService";
import { PartnerManager } from "./PartnerManager";
import { ApiKeyManager } from "./delivery/ApiKeyManager";
import { DeliveryStatusPanel } from "./delivery/DeliveryStatusPanel";

interface CustomerDetailPanelProps {
  customer: Customer;
}

export function CustomerDetailPanel({ customer }: CustomerDetailPanelProps) {
  return (
    <Stack gap="md">
      {/* APIキー管理 */}
      <ApiKeyManager
        key={`apikey-${customer.customerId}`}
        customerId={customer.customerId}
      />

      {/* 配信状況 */}
      <DeliveryStatusPanel
        key={`delivery-${customer.customerId}`}
        customerId={customer.customerId}
      />

      {/* 取引先リスト (PartnerManager) */}
      <PartnerManager
        key={customer.customerId}
        customerId={customer.customerId}
      />
    </Stack>
  );
}
